import { render, staticRenderFns } from "./ClasseAgenteField.vue?vue&type=template&id=ff2f86fc&scoped=true&"
import script from "./ClasseAgenteField.vue?vue&type=script&lang=js&"
export * from "./ClasseAgenteField.vue?vue&type=script&lang=js&"
import style0 from "./ClasseAgenteField.vue?vue&type=style&index=0&id=ff2f86fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f86fc",
  null
  
)

export default component.exports